import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Department',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Department',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'advancementCommunicationsMarketing',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Advancement Communications / Marketing',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'advancementOperations',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Advancement Operations',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'advancementStudies',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Advancement Studies',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'alumniEngagement',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Alumni Engagement',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'alumniRelations',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Alumni Relations',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'annualGiving',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Annual Giving',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'campaignOperations',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Campaign Operations',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'corporateResources',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Corporate Resources',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'developmentFundraising',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Development / Fundraising',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'development',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department: 'Development',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'donorRelationsAndStewardship',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Donor Relations and Stewardship',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'foundationRelations',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Foundation Relations',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'majorGifts',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department: 'Major Gifts',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'planningGiving',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Planning Giving',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'principalGifts',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Principal Gifts',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'prospectDevelopment',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      department:
                                                        'Prospect Development',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Department',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    majorGifts: {
      filter: {
        in: [
          'Major Gifts',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    development: {
      filter: {
        in: [
          'Development',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    annualGiving: {
      filter: {
        in: [
          'Annual Giving',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    planningGiving: {
      filter: {
        in: [
          'Planning Giving',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    principalGifts: {
      filter: {
        in: [
          'Principal Gifts',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    alumniRelations: {
      filter: {
        in: [
          'Alumni Relations',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    alumniEngagement: {
      filter: {
        in: [
          'Alumni Engagement',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    advancementStudies: {
      filter: {
        in: [
          'Advancement Studies',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    campaignOperations: {
      filter: {
        in: [
          'Campaign Operations',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    corporateResources: {
      filter: {
        in: [
          'Corporate Resources',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    foundationRelations: {
      filter: {
        in: [
          'Foundation Relations',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    prospectDevelopment: {
      filter: {
        in: [
          'Prospect Development',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    advancementOperations: {
      filter: {
        in: [
          'Advancement Operations',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    developmentFundraising: {
      filter: {
        in: [
          'Development / Fundraising',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    donorRelationsAndStewardship: {
      filter: {
        in: [
          'Donor Relations and Stewardship',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    advancementCommunicationsMarketing: {
      filter: {
        in: [
          'Advancement Communications / Marketing',
          {
            '??': [
              {
                '@.': '!impacted_groups',
              },
              {
                '[]': [],
              },
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
